// extracted by mini-css-extract-plugin
module.exports = {"automotive-banner":"automotive-banner--24yvn","automotive-banner--mobile":"automotive-banner--mobile--24yvn"};